const BOX_APPEARANCES = ['dimmed', 'neutral', 'warning', 'success', 'danger'];

export { BOX_APPEARANCES };
